/* Cart A/B test (cart_redesign_jun26) — VARIANT B injector.
   Loaded site-wide. Mutates the DOM only when html.bl-cart-b is set (bucket B).
   Applies to BOTH the cart page and the global cart drawer (#blCartDrawerRoot).
   Idempotent + guarded; re-applied on a few bounded delays after the shared
   drawer JS re-renders (offer rail / totals / items render async). NO observer. */
(function () {
  'use strict';
  function isB() { return document.documentElement.classList.contains('bl-cart-b'); }
  function isC() { return document.documentElement.classList.contains('bl-cart-c'); }

  var PAY = '<span class="blcb-pay" role="img" aria-label="Pay with Paytm, PhonePe, GPay, BHIM UPI or card"></span>';

  var A_ITEMS =
    '<span class="blcb-assure__i">COD</span>' +
    '<span class="blcb-assure__i">Free shipping</span>' +
    '<span class="blcb-assure__i">30-day returns</span>' +
    '<span class="blcb-assure__i">Extra 5% off <button type="button" class="blcb-tc" title="Extra 5% off applies to prepaid orders (UPI / cards / wallets), auto-applied at checkout.">T&amp;C</button></span>' +
    '<span class="blcb-assure__i">Inclusive of all taxes</span>';
  var ASSURE = '<div class="blcb-assure"><div class="blcb-assure__track">' + A_ITEMS + A_ITEMS + '</div></div>';

  // Variant C (arm C of cart_redesign_jun26): same B redesign, but the scrolling marquee is
  // replaced by two stacked check lines (no scroll). T&C opens the same prepaid-terms modal.
  var ASSURE_C = '<div class="blcb-assure blcb-assure--c">' +
    '<span class="blcb-assure__i">Free shipping and 30 Days Return</span>' +
    '<span class="blcb-assure__i">Extra 5% Off on all prepaid orders <button type="button" class="blcb-tc" title="Extra 5% off applies to prepaid orders (UPI / cards / wallets), auto-applied at checkout.">T&amp;C</button></span>' +
    '</div>';
  function assureHtml() { return isC() ? ASSURE_C : ASSURE; }

  // Prepaid-discount T&C popup — same content/style as the PDP's prepaid terms modal.
  function ensureTcModal() {
    var m = document.getElementById('blcbTcModal');
    if (m) return m;
    m = document.createElement('div'); m.id = 'blcbTcModal'; m.className = 'blcb-tc-modal'; m.hidden = true;
    m.innerHTML =
      '<div class="blcb-tc-modal__overlay" data-blcb-tc-close></div>' +
      '<div class="blcb-tc-modal__card" role="dialog" aria-modal="true" aria-label="Prepaid discount terms">' +
        '<div class="blcb-tc-modal__head"><h3>Prepaid discount &middot; Terms</h3><button type="button" class="blcb-tc-modal__close" data-blcb-tc-close aria-label="Close">&times;</button></div>' +
        '<div class="blcb-tc-modal__body">' +
          '<div class="blcb-tc-modal__hl"><strong>5% off on all prepaid orders</strong><span>Auto-applies at checkout when you pay online.</span></div>' +
          '<p class="blcb-tc-modal__h">Eligible payment methods:</p><ul class="blcb-tc-modal__list"><li>UPI (GPay, PhonePe, Paytm, etc.)</li><li>Credit &amp; debit cards (Visa, Mastercard, RuPay)</li><li>Net banking</li><li>Mobile wallets</li></ul>' +
          '<p class="blcb-tc-modal__h">Not eligible:</p><ul class="blcb-tc-modal__list"><li>Cash on Delivery (COD)</li><li>Gift cards or store credit</li></ul>' +
          '<p class="blcb-tc-modal__h">Other conditions:</p><ul class="blcb-tc-modal__list"><li>Stackable with bundle discounts</li><li>Discount calculated on final cart total after other discounts</li><li>No minimum order value</li><li>Applies to all products including SALE items</li></ul>' +
        '</div>' +
        '<div class="blcb-tc-modal__foot"><button type="button" class="blcb-tc-modal__gotit" data-blcb-tc-close>Got it</button></div>' +
      '</div>';
    document.body.appendChild(m);
    return m;
  }
  function closeTcModal() { var m = document.getElementById('blcbTcModal'); if (m) m.hidden = true; try { document.documentElement.style.overflow = ''; } catch (e) {} }

  function grp(n) { n = Math.round(Number(n) || 0); var s = String(Math.abs(n)); if (s.length > 3) { s = s.slice(0, -3).replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + s.slice(-3); } return s; }
  function fmtRs(rs) { return (Number(rs) < 0 ? '-₹' : '₹') + grp(rs); }
  function parseRs(t) { if (!t) return 0; var d = String(t).replace(/[^0-9]/g, ''); return d ? parseInt(d, 10) : 0; }
  function txt(root, sel) { var e = root.querySelector(sel); return e ? e.textContent : ''; }

  function enhanceTotals(root) {
    var summary = root.querySelector('.bl-cartdrawer__summary'); if (!summary) return;
    var mainRow = summary.querySelector('.bl-cartdrawer__summary-row--main'); if (!mainRow) return;
    var pw = summary.querySelector('.bl-cartdrawer__summary-price-wrap');
    if (pw && !pw.querySelector('.blcb-chev')) { var ch = document.createElement('span'); ch.className = 'blcb-chev'; pw.appendChild(ch); }
    var saved = summary.querySelector('.blcb-saved');
    if (!saved) { saved = document.createElement('div'); saved.className = 'blcb-saved'; mainRow.parentNode.insertBefore(saved, mainRow.nextSibling); }
    var bd = summary.querySelector('.blcb-bd');
    if (!bd) {
      bd = document.createElement('div'); bd.className = 'blcb-bd';
      bd.innerHTML =
        '<div class="blcb-bd-row"><span>Total MRP</span><span data-bd="mrp"></span></div>' +
        '<div class="blcb-bd-row"><span>Delivery fee</span><span class="blcb-bd-save">Free shipping</span></div>' +
        '<div class="blcb-bd-row"><span>Discount on MRP</span><span class="blcb-bd-save" data-bd="dmrp"></span></div>' +
        '<div class="blcb-bd-row"><span>Coupon discount</span><span class="blcb-bd-save" data-bd="coupon"></span></div>' +
        '<div class="blcb-bd-row blcb-bd-row--grand"><span>Grand total</span><span data-bd="grand"></span></div>' +
        '<div class="blcb-bd-banner" data-bd="banner"></div>';
      saved.parentNode.insertBefore(bd, saved.nextSibling);
    }
    if (!mainRow.getAttribute('data-blcb-toggle')) { mainRow.setAttribute('data-blcb-toggle', '1'); mainRow.addEventListener('click', function () { summary.classList.toggle('is-open'); }); }
    var G = parseRs(txt(root, '.bl-cartdrawer__summary-price')), C = parseRs(txt(root, '.bl-cartdrawer__discount-price')), S = parseRs(txt(root, '.bl-cartdrawer__savings-amount'));
    var MRP = G + S, dmrp = Math.max(0, S - C), pct = MRP > 0 ? Math.round((S / MRP) * 100) : 0;
    saved.textContent = 'You saved ' + fmtRs(S) + (pct > 0 ? ' (' + pct + '%)' : '') + '!'; saved.hidden = !(S > 0);
    function set(k, v) { var el = bd.querySelector('[data-bd="' + k + '"]'); if (el) el.textContent = v; }
    set('mrp', fmtRs(MRP)); set('dmrp', dmrp > 0 ? '-' + fmtRs(dmrp) : '₹0'); set('coupon', C > 0 ? '-' + fmtRs(C) : '₹0'); set('grand', fmtRs(G));
    var bn = bd.querySelector('[data-bd="banner"]'); if (bn) { if (S > 0) { bn.textContent = 'You Saved ' + fmtRs(S) + ' (' + pct + '%) so far!'; bn.style.display = ''; } else { bn.style.display = 'none'; } }
  }

  function flagSvg(ach) {
    var fill = ach ? '#1f9d4d' : '#efece3', stroke = ach ? '#1f9d4d' : '#bdb6a4', sym = ach ? '✓' : '₹', sc = ach ? '#ffffff' : '#8a857a';
    return '<svg viewBox="0 0 26 30" width="24" height="27" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M3 2h20a1 1 0 0 1 1 1v16l-11 8-11-8V3a1 1 0 0 1 1-1z" fill="' + fill + '" stroke="' + stroke + '" stroke-width="1.6"/>' +
      '<text x="13" y="15.5" text-anchor="middle" font-size="12" font-weight="700" fill="' + sc + '" font-family="Arial,Helvetica,sans-serif">' + sym + '</text></svg>';
  }
  function enhanceOfferRail(root) {
    var offers = root.querySelector('.bl-cartdrawer__offers'); if (!offers) return;
    var attr = root.getAttribute('data-offer-tiers') || '';
    var tiers = attr ? attr.split('|').map(function (t) { var p = t.split(':'); return { th: parseInt(p[0], 10), rw: parseInt(p[1], 10) }; }) : [];
    var head = offers.querySelector('.blcb-offer-head');
    if (!head) { head = document.createElement('div'); head.className = 'blcb-offer-head'; offers.insertBefore(head, offers.firstChild); }
    var markers = root.querySelectorAll('.bl-cartdrawer__offer-marker');
    var nextIdx = -1, anyAch = false;
    Array.prototype.forEach.call(markers, function (m, i) {
      var ach = m.classList.contains('is-achieved') || m.classList.contains('is-current-achieved');
      if (m.classList.contains('is-next')) nextIdx = i;
      if (ach) anyAch = true;
      var dot = m.querySelector('.bl-cartdrawer__offer-marker-dot');
      if (dot) { var want = ach ? 'a' : 'u'; if (dot.getAttribute('data-blcb') !== want) { dot.setAttribute('data-blcb', want); dot.innerHTML = flagSvg(ach); } }
      var tr = tiers[i];
      if (tr && tr.rw && !m.querySelector('.blcb-tier-reward')) {
        var el = document.createElement('div'); el.className = 'blcb-tier-reward'; el.textContent = 'Ext. ' + grp(tr.rw) + '/- OFF'; m.appendChild(el);
      }
    });
    var t = (nextIdx >= 0 ? tiers[nextIdx] : null) || (!anyAch ? tiers[0] : null);
    if (t && t.rw) head.textContent = 'Get Extra ₹' + grp(t.rw) + '/- off on SALE products above ₹' + grp(t.th);
    else if (anyAch) head.textContent = '🎉 You’ve unlocked the top SALE offer!';
    else head.textContent = '';
  }

  function enhanceItems(root) {
    var items = root.querySelectorAll('.bl-cartdrawer__item');
    Array.prototype.forEach.call(items, function (it) {
      if (it.querySelector('.blcb-item-main')) return;
      var content = it.querySelector('.bl-cartdrawer__content'), side = it.querySelector('.bl-cartdrawer__side');
      if (!content || !side) return;
      var qty = content.querySelector('.bl-cartdrawer__qty'), rm = side.querySelector('.bl-cartdrawer__remove');
      var main = document.createElement('div'); main.className = 'blcb-item-main';
      var top = document.createElement('div'); top.className = 'blcb-item-top';
      var actions = document.createElement('div'); actions.className = 'blcb-item-actions';
      top.appendChild(content); top.appendChild(side);
      if (rm) actions.appendChild(rm);
      if (qty) actions.appendChild(qty);
      main.appendChild(top); main.appendChild(actions);
      it.appendChild(main);
    });
  }

  function apply() {
    if (!isB()) return;
    var root = document.getElementById('blCartDrawerRoot'); if (!root) return;
    try {
      var lbl = root.querySelector('.bl-cartdrawer__summary-label');
      if (lbl && lbl.textContent.replace(/\s+/g, ' ').trim().toLowerCase() !== 'estimated total') lbl.textContent = 'Estimated total';
      var title = root.querySelector('.bl-cartdrawer__checkout-title');
      if (title && title.textContent.replace(/\s+/g, ' ').trim() !== 'Checkout') title.textContent = 'Checkout';
      if (!root.querySelector('.blcb-assure')) {
        // place the assurance marquee between the offer rail and the "Note: …SALE…" line
        var saleTip = root.querySelector('.bl-cartdrawer__sale-tip');
        var offers = root.querySelector('.bl-cartdrawer__offers');
        var sav = root.querySelector('.bl-cartdrawer__savings');
        if (isC() && offers) offers.insertAdjacentHTML('beforebegin', assureHtml());   // C: ABOVE the "Get Extra ₹…" offer rail
        else if (saleTip) saleTip.insertAdjacentHTML('beforebegin', assureHtml());
        else if (offers) offers.insertAdjacentHTML('afterend', assureHtml());
        else if (sav) sav.insertAdjacentHTML('afterend', assureHtml());
      }
      var co = root.querySelector('.bl-cartdrawer__checkout');
      if (co && !co.querySelector('.blcb-pay')) co.insertAdjacentHTML('beforeend', PAY);
      enhanceTotals(root); enhanceOfferRail(root); enhanceItems(root);
      // sticky marquee: stack it right below the (also-sticky) offer rail
      var assureEl = root.querySelector('.blcb-assure');
      if (assureEl) { var offersEl = root.querySelector('.bl-cartdrawer__offers'); assureEl.style.top = ((offersEl && !offersEl.hidden) ? offersEl.offsetHeight : 0) + 'px'; }
    } catch (e) {}
  }

  function burst(delays) { (delays || [0, 250, 700, 1500]).forEach(function (d) { setTimeout(apply, d); }); }
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    burst([0, 250, 700, 1500, 2600]);
    // The shared drawer JS fires 'bl:cart:updated' on document AFTER it re-renders with fresh
    // cart data (qty +/-, remove, add) — this is the authoritative "values changed" signal.
    try { document.addEventListener('bl:cart:updated', function () { burst([0, 120, 400, 900]); }); } catch (e) {}
    try { document.documentElement.addEventListener('cart:refresh', function () { burst([80, 350, 900, 1600]); }); } catch (e) {}
    try { var rzt; window.addEventListener('resize', function () { clearTimeout(rzt); rzt = setTimeout(apply, 120); }); } catch (e) {}
    try {
      document.addEventListener('click', function (e) {
        var t = e.target.closest && e.target.closest('[data-bl-cart-open],[data-cart-open],.js-cart-open,.bl-cartdrawer__qty-btn,.bl-cartdrawer__remove,[data-qty-action],[data-remove-item],a[href$="/cart"],a[href*="/cart?"]');
        if (t) burst([150, 500, 1100, 2000]);
      }, true);
    } catch (e) {}

    // T&C prepaid-terms popup (opens on the "T&C" link in the assurance marquee).
    try {
      document.addEventListener('click', function (e) {
        if (!e.target.closest) return;
        if (e.target.closest('.blcb-tc')) { e.preventDefault(); var m = ensureTcModal(); m.hidden = false; try { document.documentElement.style.overflow = 'hidden'; } catch (x) {} return; }
        if (e.target.closest('[data-blcb-tc-close]')) { closeTcModal(); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeTcModal(); });
    } catch (e) {}
    try {
      var V = (window.__AB_CART === 'A' || window.__AB_CART === 'B' || window.__AB_CART === 'C') ? window.__AB_CART : (isC() ? 'C' : isB() ? 'B' : 'A');
      var VNAME = V === 'C' ? "Suhail's Cart" : V === 'B' ? 'Abdul_cart (control)' : 'Old cart';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ab_cart_experiment: 'cart_redesign_jun26', ab_cart_variant: V, ab_cart_variant_name: VNAME });
      window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
      window.gtag('set', 'user_properties', { ab_cart_experiment: 'cart_redesign_jun26', ab_cart_variant: V, ab_cart_variant_name: VNAME });
    } catch (e) {}
  });
})();
